import { useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { Home, MedalStarAlt } from "@boxicons/react";
import { Community } from "@boxicons/react";
import { Images } from "@boxicons/react";
import { Spanner } from "@boxicons/react";
import { ContactBook } from "@boxicons/react";

const MainNav = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/english'); 
  };
  useEffect(() => {
    const scrollMenu = () => {
      const header = document.querySelector('nav');
      const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollPosition > 20) {
        header.classList.add('tinted');
      } else {
        header.classList.remove('tinted');
      }
    };

    window.addEventListener('scroll', scrollMenu);

    return () => {
      window.removeEventListener('scroll', scrollMenu); 
    };
  }, []);

  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };
  return (
    <nav>
      <div className="logo" onClick={() => scrollToSection('beginning')}>
        <img src='/images/logos/logoHome.png' width={50} alt="logo Anfro"></img>
      </div>
      <div className="nav-buttons" onClick={() => scrollToSection('beginning')}>
        <Home pack="filled" fill="#fff" className="i-nav"/>
        <p>Inicio</p>
      </div>
      <div className="nav-buttons" onClick={() => scrollToSection('about')}>
        <Community pack="filled" fill="#fff" className="i-nav"/>
        <p>Nosotros</p>
      </div>
      <div className="nav-buttons" onClick={() => scrollToSection('gallery')}>
        <Images pack="filled" fill="#fff" className="i-nav"/>
        <p>Galeria</p>
      </div>
      <div className="nav-buttons" onClick={() => scrollToSection('works')}>
        <Spanner pack="filled" fill="#fff" className="i-nav"/>
        <p>Servicios</p>
      </div>
      <div className="nav-buttons" onClick={() => scrollToSection('clients')}>
        <MedalStarAlt pack="filled" fill="#fff" className="i-nav"/>
        <p>Clientes</p>
      </div>
      <div className="nav-buttons" onClick={() => scrollToSection('footer')}>
        <ContactBook pack="filled" fill="#fff" className="i-nav"/>
        <p>Contacto</p>
      </div>
      <div className="nav-buttons" onClick={handleClick}>
        <p>English</p>
      </div>
    </nav>
  )
}
export default MainNav;

